export default __webpack_public_path__ + "static/media/HomeBanner4.ba161712.jpg";